import { gql } from '@urql/core';

import { defaultMutationFuction } from '../../graphql/defaultMutationFuction';

export const createStripeCustomerSessionMutation = ({ client }) => ({
  mutationFn: () =>
    defaultMutationFuction(
      client,
      gql`
        mutation CreateStripeCustomerSession {
          createStripeCustomerSession {
            clientSecret
          }
        }
      `,
      {},
    ),
});
